import { gql } from '@apollo/client';

export const fetchInternalLicensesListForDownloadCSV = gql`
  query fetchInternalLicensesListForDownloadCSV(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $isRestricted: Boolean
    $relatedDomains: [String]!
  ) {
    transactionAccount(id: $id) {
      id
      internalUseSubscriptions(
        searchOptions: $searchOptions
        filterOptions: $filterOptions
        relatedDomains: $relatedDomains
      ) {
        nodes {
          id
          activeUsers
          baseProduct
          createdDate
          billingStatus
          entitlementNumber
          latestPeriodEndDate
          productId
          cloudSiteHostname
          billingFrequency
          edition
          billingGroupId
          linkedAppsId
          orgName
          endCustomerContacts(isRestricted: $isRestricted) {
            name
          }
          subscriptionTimestamps {
            firstTrialStartTimestamp
            lastTrialEndTimestamp
          }
          upgradeTrial {
            startTimestamp
            endTimestamp
          }
        }
      }
    }
  }
`;
